import { t } from "@lingui/macro";

import { Avatar } from "@whoosh/design-system/src/components/display";
import { HoleCountIcon } from "@whoosh/design-system/src/components/icons_v2/courseLayout";
import { GetTransportIconFromCode } from "@whoosh/design-system/src/components/icons_v2/transportation";
import {
  HStack,
  VStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { HoleCount } from "../OtherPlayersInThisBooking/__generated__/OtherPlayersInThisBooking_Booking.graphql";

export type OtherPlayerRowProps = {
  firstName: string;
  lastName: string;
  fullName: string;
  holeCount?: HoleCount;
  transportationTypeCode?: string;
  isOwner: boolean;
};

export const OtherPlayerRow = ({
  firstName,
  lastName,
  fullName,
  holeCount,
  transportationTypeCode,
  isOwner,
}: OtherPlayerRowProps) => {
  const transportationIcon = transportationTypeCode
    ? GetTransportIconFromCode(transportationTypeCode)
    : null;

  return (
    <HStack alignItems="center" gap={3} paddingVertical={2}>
      <Avatar size="tiny" firstName={firstName} lastName={lastName} />
      <Text variant="mainBaseSemiBold">{fullName}</Text>
      <HStack gap={2} alignItems="center">
        {holeCount ? <HoleCountIcon holeCount={holeCount} /> : null}
        {transportationIcon ? transportationIcon({}) : null}
        {isOwner ? (
          <VStack
            padding={1}
            alignItems="center"
            justifyContent="center"
            borderWidth={1}
            borderColor="outline-default"
            borderRadius="2"
          >
            <Text variant="mainMicro">{t`OWNER`}</Text>
          </VStack>
        ) : null}
      </HStack>
    </HStack>
  );
};
